module.exports = "data:text/markdown;base64,IyMjIFJldmVudWU6CkEgdG90YWwgaW4gZG9sbGFycyBnZW5lcmF0ZWQgZm9yIGEgY2FtcGFpZ24uCg=="